import BaseVariableConfigurationsRestApi, { BaseVariableConfigurationsApi } from './Base/BaseVariableConfigurationsApi';

export type IntermediaryVariableConfigurationsApi = BaseVariableConfigurationsApi;

export default class IntermediaryVariableConfigurationsRestApi extends BaseVariableConfigurationsRestApi
  implements IntermediaryVariableConfigurationsApi {
  protected resourceName = 'intermediary-variable-configurations';
}
